module.exports = __webpack_public_path__ + "static/media/hero.197cfae9.png";